import { createCli } from './cli.js';

const cli = createCli();
cli.parse();
